import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useDeleteNode = (flowID, crId) => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);

  const {
    isLoading,
    isSuccess,
    isError,
    data,
    mutate,
  } = useMutation(
    `node-delete-${orgId}-${flowID}`,
    (nodeID) => axiosInstance.delete(flow(orgId)
      .deleteNode(crId, flowID, nodeID)),
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Node has been deleted.',
          type: 'success',
        }));
      },
      onError: (error) => dispatch(showAlert({
        message: error.response.data.message,
        type: 'error',
      })),
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    mutate,
  };
};
